import { FilterDtoProps } from 'components/common/ComposableFilters/FiltersDto';

export enum GroupBy {
  Week = 'week',
  Day = 'day',
  Month = 'month',
}

export enum DateRangeLabel {
  Last7Days = 'Last 7 days',
  Last30Days = 'Last 30 days',
  Last90Days = 'Last 90 days',
  Last365Days = 'Last 365 days',
  LastWeek = 'Last week',
  LastMonth = 'Last month',
  LastQuarter = 'Last quarter',
  LastYear = 'Last year',
  YearToDate = 'Year to date',
}

export interface DateRangeOption {
  label: DateRangeLabel;
  start_date: string;
  end_date: string;
  groupBy: GroupBy[];
}

export interface Metric {
  id: string;
  label: string;
  format: 'currency' | 'percent' | 'number';
  description: string;
  learnMoreUrl: string;
  expandedCard: boolean;
  defaultSelected: boolean;
  filters: FilterDtoProps | null;
}
